import { useCallback } from 'react'

import { useActiveOrgId } from '~/hooks/org'
import { useNavigation } from '~/hooks/useNavigation'
import { useCookieStore } from '~/store/cookieStore'
import { AuthUserOrg } from '~/types'

export function useSetActiveOrg(): {
  setActiveOrg: (org: AuthUserOrg, destinationPath?: string) => void
} {
  const navigate = useNavigation()
  const setActiveOrgId = useCookieStore((s) => s.setActiveOrgId)
  const activeOrgId = useActiveOrgId()

  const setActiveOrg = useCallback(
    (org: AuthUserOrg, destinationPath?: string) => {
      if (org.id === activeOrgId) return
      setActiveOrgId(org.id)
      if (destinationPath) navigate(destinationPath)
    },
    [navigate, setActiveOrgId, activeOrgId],
  )

  return { setActiveOrg }
}
